import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { useEffect, useState, useRef } from "react";
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import DashboardKycSideBar from '../dashboard/dashboardSidebar';
import VerificationService from "../service/VerificationService";
import { printDiv } from '../kyc/declerationDetails';
import ViewCompanyData from '../kyc/viewCompanyData';
import ViewFormData from '../kyc/viewFormData';
import { useReactToPrint } from 'react-to-print';

const KycView = props => {
  const history = useHistory();
  const { t, i18n } = useTranslation();
  const { status, customerId, formType } = useSelector((state) => state.routerData) || {};
  const componentRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  return (
    <div className='p-grid'>
      <div id='kycForm' className='p-col-12 p-md-9 compact-layout'>
        <div
          style={{ padding: 25, height: '95vh' }}
          className='p-col-12 p-md-12'
        >
          {status === 'R' && <RequestForModificationView kycId={customerId} />}
          <Card
            className='main-card'
            header={
              <>
                <h3 className='p-col-12 p-md-12 text-center'>
                  <i className='pi pi-user' /> {t('yourKycDetails')}
                </h3>{' '}
                <Button
                  className='p-col-12 p-md-2 pull-right add-button'
                  label={'Back'}
                  type='submit'
                  style={{ width: 100 }}
                  onClick={() => history.push('/kyc/dashboard')}
                />
                <Button
                  className='p-button-success add-button'
                  onClick={handlePrint}
                  //   onClick={() => printDiv('declarationPage2')}
                  style={{
                    float: 'right',
                    justifyContent: 'center',
                    marginRight: 10,
                  }}
                >
                  Print
                </Button>
              </>
            }
          >
            {/* <iframe
              id='ifmcontentstoprint'
              style={{ height: 0, width: 0, position: 'absolute' }}
            ></iframe> */}
            <div id='declarationPage2' ref={componentRef}>
              {formType === 'I' ? <ViewFormData /> : <ViewCompanyData />}
            </div>
          </Card>
        </div>
      </div>
      <DashboardKycSideBar />
    </div>
  );
};


export const RequestForModificationView = (props) => {
  const [data, setData] = useState();

  useEffect(() => {
    VerificationService.detail(props.kycId).then((response) => {
      setData(response.data);
    });
  }, []);

  // if (data && data.length)
  //   return (
  //     <Card className="p-col-12" title="Messages from verifier">
  //       <div className="p-fluid">
  //         {data &&
  //           data.map((message) => (
  //             <p className="p-col-12 p-md-12">{message.message}</p>
  //           ))}
  //       </div>
  //     </Card>
  //   );
  // else
  return <div></div>;
};

export default KycView;
